import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, of, switchMap, withLatestFrom } from 'rxjs';

import { ErrorHandlerService } from '../../../services/error-handler/error-handler.base-service';
import { NotificationSettingsFacade } from '../../../services/notifications/notification-settings.facade';
import * as fromActions from './notification-settings.actions';
import { getHasMissingMandatoryConsent } from '../../account';

@Injectable()
export class NotificationSettingsEffects {
  private actions$ = inject(Actions);
  private notificationSettingsFacade = inject(NotificationSettingsFacade);
  private errorHandlerService = inject(ErrorHandlerService);
  private store = inject(Store);

  loadNotificationSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.LoadNotificationSettings),
      withLatestFrom(this.store.select(getHasMissingMandatoryConsent)),
      switchMap(([action, hasMissingMandatoryConsent]) => {
        if (hasMissingMandatoryConsent === null || hasMissingMandatoryConsent) {
          return of({
            type: '[NotificationSettingsEffects] Skipped - Consent Missing',
            payload: action,
          });
        }
        return this.notificationSettingsFacade.getNotificationSettings().pipe(
          map(success => fromActions.LoadNotificationSettingsSuccess({ success })),
          catchError(error => {
            this.errorHandlerService.handleError(
              '(REQUEST ERROR) on notifications-settings.effects.ts:loadNotificationSettings$:',
              error
            );
            return [fromActions.LoadNotificationSettingsFailed({ error })];
          })
        );
      })
    );
  });

  changeNotificationSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.ChangeNotificationSettings),
      switchMap(({ payload }) =>
        this.notificationSettingsFacade.updateNotificationSettings(payload).pipe(
          map(response => fromActions.ChangeNotificationSettingsSuccess({ response })),
          catchError(error => {
            this.errorHandlerService.handleError(
              '(REQUEST ERROR) on notifications-settings.effects.ts:changeNotificationSettings$:',
              error
            );
            return [fromActions.ChangeNotificationSettingsFailed({ error })];
          })
        )
      )
    );
  });
}
